'use client';

import { useEffect, useRef } from 'react';
import Lenis from 'lenis';

const SmoothScrollProvider = ({ children }) => {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1,
      easing: t => t, // Linear easing
      smooth: true,
      direction: 'vertical',
      gestureDirection: 'both',
      smoothTouch: true,
      touchMultiplier: 1, // Default multiplier for touch devices
      infinite: false,
    });

    lenisRef.current = lenis;

    const handleRAF = time => {
      lenis.raf(time);
      requestAnimationFrame(handleRAF);
    };

    requestAnimationFrame(handleRAF);

    return () => {
      lenis.destroy(); // Properly clean up Lenis instance
    };
  }, []);

  return <>{children}</>;
};

export default SmoothScrollProvider;
